import React, { useState } from 'react';

const TimeRestriction = ({ updateFormData, nextStep, prevStep }) => {
  const [showWaiverMessage, setShowWaiverMessage] = useState(false);

  const handleAnswer = (answer) => {
    if (answer === true) {
      // Show waiver message for 24-hour restriction
      setShowWaiverMessage(true);
    } else {
      updateFormData({ planningWithin24Hours: answer });
      nextStep();
    }
  };

  const handleContinue = () => {
    updateFormData({ planningWithin24Hours: true });
    nextStep();
  };

  if (showWaiverMessage) {
    return (
      <div className="question-screen">
        <h1 className="question-title">TIME RESTRICTIONS</h1>

        <div className="question-content">
          <div className="waiver-notice">
            <p>
              When you arrive, the deputy clerk will direct you to a Judge or Justice of the Peace to obtain a waiver.
              The Clerk of Court's fee for this service is $4.00. The Judge or Justice of the Peace granting the waiver
              may charge an additional fee and may require information supporting the need for the waiver.
            </p>
          </div>
        </div>

        <div className="question-actions">
          <button onClick={() => setShowWaiverMessage(false)} className="btn btn-secondary">
            Back to Previous Question
          </button>
          <button onClick={handleContinue} className="btn btn-primary">
            Continue Application
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="question-screen">
      <button onClick={prevStep} className="btn btn-secondary question-back-button">
        Back to Previous Question
      </button>

      <h1 className="question-title">TIME RESTRICTIONS</h1>

      <div className="question-content">
        <p>
          Marriage licenses are valid for thirty days from the time issued by the deputy clerk. The license may not be used
          within 24 hours, unless a waiver is obtained.
        </p>

        <p className="question-prompt">
          Do you plan to marry within 24 hours from the time the license is issued?
        </p>
      </div>

      <div className="question-buttons">
        <button onClick={() => handleAnswer(true)} className="question-btn yes">Yes</button>
        <button onClick={() => handleAnswer(false)} className="question-btn no">No</button>
      </div>
    </div>
  );
};

export default TimeRestriction;
